import React from 'react';
import EdTechPlatformHeader from '../Header/EdTechPlatformHeader/EdTechPlatformHeader';
// import './EdTechPlatform.css';

const EdTechPlatform = () => (
  <section className="product-display-container" id="etp">
    <EdTechPlatformHeader />
    <div className="product-detail-grid">
      <div className="detail-narrative">
        <h3>Multi-Tenant Academic Orchestration</h3>
        <p className="p__opensans">
          The ETP Platform provides cloud-native learning infrastructure optimized for scalable multimedia delivery.
          Using an advanced ReactJS frontend connected to serverless storage architectures, it tracks, parses, and surfaces actionable
          instructional intelligence insights for institutional system operators.
        </p>
        <a href="https://www.curvsort.com/productsList" target="_blank" rel="noreferrer" className="appstore-action-link">
          Review Platform Architecture ↗
        </a>
      </div>
      <div className="detail-specs-box">
        <h4>Telemetry Specifications</h4>
        <ul>
          <li>Architecture: ReactJS Coupled with Serverless AppSync Microservices</li>
          <li>Intelligence Engine: Amazon Nova Integration Pipeline</li>
          <li>Target Profiles: K-12 Academies, Corporate Compliance Networks</li>
        </ul>
      </div>
    </div>
  </section>
);

export default EdTechPlatform;
